export const DATA_TEST_IDS = {
  MENU: 'reports_request_menu',
  MENU_BY_DAYS: 'reports_request_menu_by_days',
  MENU_BY_DAYS_ICON: 'reports_request_menu_by_days_icon',
  MENU_EARLY: 'reports_request_menu_early',
  MENU_EARLY_ICON: 'reports_request_menu_early_icon',
  TRIGGER: 'reports_request_menu_trigger',
};
